export default "__VITE_ASSET__a367f482__"